import { useSelector } from 'react-redux';

import { kioskEnabled } from 'store/kiosk/selectors';

export default function useKioskEnabled(): boolean {
  return useSelector(kioskEnabled);
}
